import { css } from '@emotion/css';

export const numberInputWidth = css`
  width: 26.5%;
`;

export const operatorListWidth = css`
  width: 13rem;
`;
